import { gql } from 'apollo-angular';

import { Result } from '@graphql/shared/types/result.type';

import { UserSchema } from '../schemas/user.schema';

export type GetUserByIdResult = Result<'userById', UserSchema>;

export interface GetUserByIdVariables {
  id: string;
}

export const GET_USER_BY_ID = gql<GetUserByIdResult, GetUserByIdVariables>`
  query getUserById($id: UUID!) {
    userById(id: $id) {
      accessFailedCount
      dateUpdated
      email
      emailConfirmed
      firstName
      id
      isPasswordExpired
      lastName
      lockoutEnabled
      lockoutEnd
      normalizedEmail
      normalizedUserName
      phoneExtension
      phoneNumber
      phoneNumberConfirmed
      prefix
      suffix
      twoFactorEnabled
      userName
      usersInOrg {
        claimPrefix
        dateCreated
        dateExpire
        dateStart
        dateUpdated
        displayOrder
        id
        isStaff
        orgId
        userId
        org {
          claimPrefix
          dateCreated
          dateExpire
          dateStart
          dateUpdated
          id
          orgCode
          orgName
          orgType
          requireMFA
          tpaRule
          tpaRuleFilter
        }
        orgUsersForOrgRole {
          applicationServiceId
          claimPrefix
          dateCreated
          dateExpire
          dateStart
          id
          orgId
          roleOrgId
          userOrgId
          orgRole {
            claimPrefix
            dateCreated
            dateExpire
            dateStart
            id
            orgId
            orgInServiceId
            serviceRoleId
            serviceRole {
              applicationServiceId
              claimPrefix
              copiedFromTemplateId
              dateCreated
              dateExpire
              dateStart
              id
              isTemplate
              name
            }
          }
        }
      }
    }
  }
`;
